import React from 'react'
import { Button, Modal } from 'react-bootstrap'

export const FullHistoryAndGamesModalGreenbet = ({ show, handleClose, bonificationsData }: { show: boolean, handleClose: () => void, bonificationsData: any }) => {

    const getHistoryColor = (e: any) => {
        if (e[3] === 'Bonificacion') { return 'orange' }
        if (parseFloat(e[4]?.replace(",", ".")) < 0) return 'red'
        if (parseFloat(e[4]?.replace(",", ".")) > 0) return 'green'
    }


    return (
        <Modal show={show} onHide={handleClose} size="lg" centered={true} aria-labelledby="contained-modal-title-vcenter">
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    Historial de transacciones
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div style={{ minHeight: '500px' }}>

                    <div>
                        <h5>Historial de Cargas/Retiros</h5>

                        <div className='d-flex justify-content-start'>

                            <div>
                                {bonificationsData?.coinsData?.map((item: any) => (
                                    <div key={item.id}>
                                        <span style={{ color: getHistoryColor(item) }}>[{item[0]}] {item[4]} <span style={{ color: 'gray' }}>( {item[3]} )</span></span><br />
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                    <hr />
                    <div >
                        <h5>Historial de Juegos</h5>

                        <div className='d-flex justify-content-center'>
                            {bonificationsData?.gamesData && (
                                <>
                                    <div className="table-responsive mt-3">
                                        <table className="table">
                                            <thead>
                                                <tr>
                                                    <th>Fecha</th>
                                                    <th>Proveedor</th>
                                                    <th>Juego</th>
                                                    <th>Operacion</th>
                                                    <th>Importe</th>
                                                    <th>Saldo Anterior</th>
                                                    <th>Saldo Posterior</th>

                                                </tr>
                                            </thead>
                                            <tbody>
                                                {bonificationsData?.gamesData?.map((entry: any, index: number) => (
                                                    <tr key={index}>
                                                        <td>{entry[0]}</td>
                                                        <td>{entry[1]}</td>
                                                        <td>{entry[2]}</td>
                                                        <td>{entry[4]}</td>
                                                        <td>{entry[5]}</td>
                                                        <td>{entry[6]}</td>
                                                        <td>{entry[7]}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                        {
                                            bonificationsData?.gamesData?.length === 0 && <div className='d-flex justify-content-center my-5'>
                                                <span>No hay historial</span>
                                            </div>
                                        }
                                    </div>
                                </>
                            )}
                        </div>
                    </div>

                </div>

            </Modal.Body>
            <Modal.Footer>
                <Button variant='dark' onClick={handleClose}>Cerrar</Button>
            </Modal.Footer>
        </Modal>
    );
};
